import * as React from "react";
import { Column } from "primereact/column";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataTable } from "primereact/datatable";
import { getDateTime, filterDateTime, renderHeader, DropdownFilterElement } from "../../components/TableUtils";
import ViewCustVehDev from "../../components/DeviceVehCustModal";
import classNames from 'classnames';
import { deleteTicket } from "../../api/tickets";

export default function TicketList() {

    let dtable;

    const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("tickets", "createdat desc", undefined, "")

    const [openModal, setOpenModal] = React.useState(false);
    const toggle = () => setOpenModal(!openModal);

    const onDelete = async id => {
        const value = await deleteTicket(id);
        toggle();
        forceRefresh();
        return value;
    };

    const modalSection = () => (
        <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
            <ModalHeader toggle={toggle}>
                Eliminazione Ticket
        </ModalHeader>
            <ModalBody>
                <p>Confermi di voler eliminare il Ticket?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
                <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
            </ModalFooter>
        </Modal>
    );

    const getHeader = () => {
        return (
            <Can
                roles={[roles.ADMIN, roles.CENTRALE]}
                yes={() => (
                    <div className="action-container">
                        <Link
                            title="Aggiungi Ticket"
                            className="btn btn-primary p-button-icon-only"
                            to={`/centrale/add-ticket`}
                        >
                            <i className="pi pi-plus mr-2"></i>Nuovo Ticket
                        </Link>
                    </div>
                )}
                no={() => null}
            />
        );
    };

    const onRefresh = () => {
        forceRefresh();
        setGlobalFilter("");
    }

    const exportTable = () => {
        dtable.exportCSV();
    }

    return (
        <PageLayout title="Elenco Ticket">
            <Row>
                <Col>
                    <DataTable
                        ref={el => {
                            dtable = el;
                        }}
                        loading={loading}
                        value={result}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={20}
                        totalRecords={result.length}
                        paginatorPosition="both"
                        header={renderHeader(loading, result.length, undefined, getHeader(), { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
                        globalFilter={globalFilter}
                        emptyMessage={() => (<div className="text-center">Nessun ticket in tabella</div>)}
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Visualizzati {first} di {last} Veicoli su un totale di {totalRecords}"
                    >
                        <Column
                            style={{ wordWrap: "break-word" }}
                            header="Nome"
                            sortable
                            filter
                            filterMatchMode="contains"
                            field="attributes.customer_name"
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/centrale/work-ticket/${rowData._id}`}
                                    >
                                        {rowData.attributes.customer_name}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="attributes.number"
                            style={{ wordWrap: "break-word" }}
                            header="Telefono"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="attributes.plate"
                            style={{ wordWrap: "break-word" }}
                            header="Targa"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="attributes.imei"
                            style={{ wordWrap: "break-word" }}
                            header="IMEI"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="createdat"
                            header="Creato il"
                            sortable
                            filter
                            filterMatchMode="custom"
                            filterFunction={filterDateTime}
                            body={getDateTime}
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="updatedat"
                            header="Ultimo aggiornamento"
                            sortable
                            filter
                            filterMatchMode="custom"
                            filterFunction={filterDateTime}
                            body={getDateTime}
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="updatedby"
                            header="Aggiornato da"
                            sortable
                            filter
                            filterMatchMode="contains"
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="status"
                            header="Stato"
                            sortable
                            filter
                            style={{ wordWrap: "break-word", textAlign: "center" }}
                            filterElement={
                                <DropdownFilterElement
                                    field="status"
                                    options={[
                                        { label: "aperto", value: "aperto" },
                                        { label: "chiuso", value: "chiuso" }
                                    ]}
                                    onChange={e => dtable.filter(e.value, e.field)}
                                />
                            }
                            body={(rowData, column) => {
                                return (
                                    <span className={classNames('customer-badge', 'status-' + rowData.status)}>{rowData.status}</span>
                                );
                            }}
                        />
                        <Column
                            field="actions"
                            body={(rowData, column) => {
                                return (
                                    <div className="action-container">
                                        <Link
                                            title="Gestisci Ordine"
                                            className="btn btn-sm btn-primary p-button-icon-only mr-1"
                                            to={`/centrale/work-ticket/${rowData._id}`}
                                        >
                                            <FontAwesomeIcon icon="pencil-alt" />
                                        </Link>
                                        {false && <ViewCustVehDev idDevice={rowData.attributes.device_id} idVehicle={rowData.attributes.vehicle_id} idCustomer={rowData.attributes.customer_id} />}
                                        <Can
                                            roles={[roles.ADMIN]}
                                            yes={() => (
                                                <Button
                                                    color="danger"
                                                    title="Elimina ticket"
                                                    onClick={() => setOpenModal(rowData)}
                                                    className="btn-sm p-button-icon-only"
                                                >
                                                    <FontAwesomeIcon icon="trash-alt" />
                                                </Button>
                                            )}
                                            no={() => null}
                                        />
                                    </div>
                                );
                            }}
                            style={{ wordWrap: "break-word" }}
                        />
                    </DataTable>
                </Col>
            </Row>
            {modalSection()}
        </PageLayout>
    );
}